interface MapProps {
  key: string,
  value: string,
}

export const asParams = (map: MapProps[]):string => {
  var params:string = '';
  map.forEach((map) => params += map.value ? `&${map.key}=${map.value}` : '');
  return params.replace(/\&/, '');
}